import RestHelper from "utils/RestHelper";
import { downloadWithUrl } from "utils/file-utils";
export const CosUtil = {
    parseBucketPath(bucketPath) {
        const [bucket, _, cosKey] = bucketPath.split('/', 3);
        return { bucket, cosKey };
    },
    /** 从cos/S3的URL里面解析出bucket和cosKey。如果不能正常解析，则bucket和cosKey都为空字符串。 */
    parseCosUrl(cosUrl) {
        // URL的格式如下：https://{bucket}.{domain}/{cosKey}
        try {
            // 如果不是以 https:// 开头，先加上
            let url = cosUrl;
            if (!url.startsWith('https://') && !url.startsWith('http://')) {
                url = 'https://' + url;
            }
            // 使用 URL 构造函数解析
            const urlObj = new URL(url);
            // 从 hostname 中提取 bucket（第一个点号前面的部分）
            const bucket = urlObj.hostname.split('.')[0];
            // 从 pathname 中提取 cosKey（去掉开头的斜杠）
            const cosKey = urlObj.pathname.startsWith('/') ? urlObj.pathname.substring(1) : urlObj.pathname;
            return { bucket, cosKey };
        }
        catch (e) {
            // 解析失败，返回空字符串
            console.error('Failed to parse COS URL:', cosUrl, e);
            return { bucket: '', cosKey: '' };
        }
    },
    /** 使用生成预签名URL的方式，下载cos上面的文件 */
    async downloadFileViaPresignedUrl(appId, bucket, cosKey, filename) {
        // 调用接口生成预签名 URL，传递 filename 参数让后端在 URL 中包含 Content-Disposition 头
        // 这样浏览器会强制下载而不是展示文本文件
        const rsp = await RestHelper.mustPost('/redir/api/file/makePresignedUrl', {
            appId,
            bucket,
            cosKey,
            filename, // 传递 filename，后端会在预签名 URL 中添加 response-content-disposition 参数
        }, undefined);
        const { url } = rsp.json.data;
        // 直接使用预签名 URL 触发浏览器原生下载
        downloadWithUrl(filename, url);
    },
};
